import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth'

import { auth } from '../config/firebase.config'

export const hasStaffPasswordSession = (): boolean => !!auth.currentUser?.email

export const confirmStaffPassword = async (password: string): Promise<void> => {
  const user = auth.currentUser
  if (!user?.email) {
    throw new Error('NO_STAFF_SESSION')
  }
  await reauthenticateWithCredential(user, EmailAuthProvider.credential(user.email, password))
}

export const refreshStaffSignIn = async (password: string): Promise<void> => {
  await confirmStaffPassword(password)
  await auth.currentUser?.getIdToken(true)
}
